import NavSocialMedia from "./NavSocialMedia";

export default NavSocialMedia;
